import axios from "axios"
import BASE_URL from "./apiConfig"

const PostToAPI = async (url, paramsObj, headersObj = {}) => {
  url = `${BASE_URL}/api/${url}`

  // Retrieve and parse the token
  const token = localStorage.getItem("authUser")
  let tokenid = ""
  if (token) {
    try {
      const parsedToken = JSON.parse(token)
      tokenid = parsedToken?.access_token || ""
    } catch (error) {
      console.error("Error parsing token:", error)
    }
  }

  // Add Authorization header if token exists
  const headers = tokenid
    ? { ...headersObj, Authorization: `Bearer ${tokenid}` }
    : headersObj

  try {
    const response = await axios.post(url, paramsObj, { headers })
    return response.data
  } catch (error) {
    // Handle error appropriately
    return error.response
      ? error.response.data
      : { error: "An unknown error occurred" } || error.message
  }
}

export default { PostToAPI }
